import { Analytics } from '@vercel/analytics/react';
import { useState, useEffect } from 'react';

import { PageContext } from './components/PageContext';
import Navbar from './components/Navbar/Navbar';
import Home from './screens/Home';
import About from './screens/About';
import Experience from './screens/Experience';
import Projects from './screens/Projects';
import Contact from './screens/Contact';

interface MousePosition {
  x: number;
  y: number;
}

function App() {
  const [mousePosition, setMousePosition] = useState<MousePosition>({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      requestAnimationFrame(() => {
        setMousePosition({ x: e.clientX, y: e.clientY });
      });
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1, rootMargin: '-50px' }
    );

    document.querySelectorAll('.animate-in').forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="min-h-screen relative" id='root-content'>
      <div className="bg-base" />
      <div className="bg-orbs" />
      <div className="bg-grid" />
      <div className="bg-noise" />
      
      <div 
        className="cursor-glow hidden lg:block"
        style={{ left: mousePosition.x, top: mousePosition.y }}
      />

      <PageContext.Provider value={{ screen: 'desktop' }}>
        <Navbar />
        
        <main>
          <Home />
          <About />
          <Experience />
          <Projects />
        </main>

        <Contact />
      </PageContext.Provider>
      
      <Analytics />
    </div>
  );
}

export default App;
